<template #content>

    <div class="w-full">
        <div class="field mt-4 flex gap-2">
            <div class="w-6">
                <FloatLabel>
                    <Select
                        id="solicitante_id"
                        v-model="form.solicitante_id"
                        :options="solicitanteOpt"
                        optionLabel="descricao"
                        optionValue="id"
                        class="w-full"
                        filter
                        showClear
                        :loading="isLoadingSolicitanteOpt"
                        :disabled="solicitanteOpt.length <= 1" />
                    <label for="solicitante_id">Solicitante<span class="text-red-500">*</span></label>
                </FloatLabel>
                <div class="text-xs text-red-500">{{ errors['solicitante_id'] }}</div>
            </div>

            <div class="w-6">
                <InputGroup>
                    <FloatLabel>
                        <InputText id="cliente_id" v-model="form.cliente" class="w-full" readonly />
                        <label for="cliente_id">Cliente<span class="text-red-500">**</span></label>
                    </FloatLabel>
                    <Button icon="pi pi-search" severity="info" @click="visibleClienteListaSelect = true"></Button>
                    <Button icon="pi pi-times" severity="danger" @click="clearCliente"></Button>
                </InputGroup>
                <div class="text-xs text-red-500">{{ errors['cliente_id'] }}</div>
            </div>
        </div>

        <div class="field mt-4 flex gap-2">
            <div class="w-3">
                <FloatLabel>
                    <InputText id="id_primario" v-model="form.id_primario" class="w-full" />
                    <label for="id_primario">ID Primário<span class="text-red-500">**</span></label>
                </FloatLabel>
                <div class="text-xs text-red-500">{{ errors['id_primario'] }}</div>
            </div>

            <div class="w-3">
                <FloatLabel>
                    <InputText id="id_secundario" v-model="form.id_secundario" class="w-full" />
                    <label for="id_secundario">ID Secundário</label>
                </FloatLabel>
                <div class="text-xs text-red-500">{{ errors['id_secundario'] }}</div>
            </div>

            <div class="w-4">
                <InputGroup>
                    <InputGroupAddon>R$</InputGroupAddon>
                    <FloatLabel>
                        <InputNumber id="valor_referencia" v-model="form.valor_referencia" :minFractionDigits="2" :maxFractionDigits="5" fluid />
                        <label for="valor_referencia">Valor de Referência</label>
                    </FloatLabel>
                </InputGroup>
                <div class="text-xs text-red-500">{{ errors['valor_referencia'] }}</div>
            </div>
            <div class="w-2">
                <InputGroup>
                    <FloatLabel>
                        <InputNumber id="duracao" v-model="form.duracao" fluid />
                        <label for="duracao">Duração</label>
                    </FloatLabel>
                    <InputGroupAddon>&nbsp;mêses&nbsp;</InputGroupAddon>
                </InputGroup>

                <div class="text-xs text-red-500">{{ errors['duracao'] }}</div>
            </div>

            <div class="w-2">
                <FloatLabel>
                    <DatePicker id="data_vencimento" v-model="form.data_vencimento" showIcon class="w-full" dateFormat="dd/mm/yy" />
                    <label for="data_vencimento">Vencimento</label>
                </FloatLabel>
                <div class="text-xs text-red-500">{{ errors['data_vencimento'] }}</div>
            </div>
        </div>

        <div class="field mt-4 flex gap-2">
            <div class="w-6">
                <FloatLabel>
                    <InputText id="site" v-model="form.site" class="w-full" />
                    <label for="site">Site/Localidade<span class="text-red-500">*</span></label>
                </FloatLabel>
                <div class="text-xs text-red-500">{{ errors['site'] }}</div>
            </div>

            <div class="w-4">
                <InputGroup>
                    <FloatLabel>
                        <InputNumber v-model="form.sla" fluid />
                        <label>SLA</label>
                    </FloatLabel>
                    <InputGroupAddon>Horas</InputGroupAddon>
                </InputGroup>
                <div class="text-xs text-red-500">{{ errors['sla'] }}</div>
            </div>
            <div class="w-2 flex align-content-center">
                <div class="flex align-items-center gap-2">
                    <Checkbox v-model="form.sla_nbd" inputId="sla_nbd" :trueValue="1" :falseValue="0" binary />
                    <label for="sla_nbd">NBD</label>
                </div>
            </div>
        </div>

        <div class="field mt-4 flex gap-2">
            <div class="w-5">
                <FloatLabel>
                    <InputText id="velocidade" v-model="form.velocidade" class="w-full" />
                    <label for="velocidade">Velocidade</label>
                </FloatLabel>
                <div class="text-xs text-red-500">{{ errors['velocidade'] }}</div>
            </div>

            <div class="w-5">
                <FloatLabel>
                    <InputText id="tipo_link" v-model="form.tipo_link" class="w-full" />
                    <label for="tipo_link">Tipo de Link</label>
                </FloatLabel>
                <div class="text-xs text-red-500">{{ errors['tipo_link'] }}</div>
            </div>

            <div class="w-2 flex align-content-center">
                <div class="flex align-items-center gap-2">
                    <Checkbox v-model="form.aguarda_aprovacao" inputId="aguarda_aprovacao" :trueValue="1" :falseValue="0" binary />
                    <label for="aguarda_aprovacao">Aguarda Aprovação</label>
                </div>
            </div>
        </div>

        <Panel class="contrato-endereco mt-4" >
            <template #header>
                <div class="font-semibold">
                    <i class="pi pi-map-marker"></i> Endereço
                </div>
            </template>

            <div class="field mt-4 flex gap-2">
                <div class="w-4">
                    <InputGroup>
                        <FloatLabel>
                            <InputMask id="cep" v-model="form.cep" mask="99999-999" class="w-full" :loading="isLoadingCep" />
                            <label for="cep">CEP</label>
                        </FloatLabel>
                        <Button icon="pi pi-search" severity="info" @click="onCepChange" :loading="isLoadingCep"></Button>
                    </InputGroup>
                    <div class="text-xs text-red-500">{{ errors['cep'] }}</div>
                </div>

                <div class="w-4">
                    <FloatLabel>
                        <Select
                            id="estado_id"
                            v-model="form.estado_id"
                            :options="estadoOpt"
                            optionLabel="nome"
                            optionValue="id"
                            class="w-full"
                            filter
                            showClear
                            :loading="isLoadingEstadoOpt || isLoadingCep"
                            @change="onEstadoChange" />
                        <label for="estado_id">Estado</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['estado_id'] }}</div>
                </div>

                <div class="w-4">
                    <FloatLabel>
                        <Select
                            id="cidade_id"
                            v-model="form.cidade_id"
                            :options="cidadeOpt"
                            optionLabel="nome"
                            optionValue="id"
                            class="w-full"
                            filter
                            showClear
                            :loading="isLoadingCidadeOpt || isLoadingCep" />
                        <label for="cidade_id">Cidade</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['cidade_id'] }}</div>
                </div>


            </div>

            <div class="field mt-4 flex gap-2">
                <div class="w-12">
                    <FloatLabel>
                        <InputText id="endereco1" v-model="form.endereco1" class="w-full" :loading="isLoadingCep" />
                        <label for="endereco1">Logradouro</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['endereco1'] }}</div>
                </div>
            </div>

            <div class="field mt-4 flex gap-2">
                <div class="w-12">
                    <FloatLabel>
                        <InputText id="endereco2" v-model="form.endereco2" class="w-full" :loading="isLoadingCep" />
                        <label for="endereco2">Complemento</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['endereco2'] }}</div>
                </div>
            </div>
        </Panel>

        <div class="field mt-4 flex gap-2">
            <div class="w-6">
                <FloatLabel>
                    <Select
                        id="etapa"
                        v-model="form.etapa"
                        :options="etapaOpt"
                        optionLabel="descricao"
                        optionValue="id"
                        class="w-full"
                        filter
                        :loading="isLoadingEtapaOpt"
                        :disabled="!permissoes.CONTRATO_EDITAR_ETAPA" />
                    <label for="etapa">Etapa<span class="text-red-500">*</span></label>
                </FloatLabel>
                <div class="text-xs text-red-500">{{ errors['etapa'] }}</div>
            </div>

            <div class="w-6">
                <FloatLabel>
                    <Select
                        id="responsavel_id"
                        v-model="form.responsavel_id"
                        :options="responsavelOpt"
                        optionLabel="nome"
                        optionValue="id"
                        class="w-full"
                        filter
                        showClear
                        :loading="isLoadingEtapaOpt"
                        :disabled="!permissoes.CONTRATO_ALTERAR_RESPONSAVEL" />
                    <label for="responsavel_id">Responsável</label>
                </FloatLabel>
                <div class="text-xs text-red-500">{{ errors['responsavel_id'] }}</div>
            </div>
        </div>

        <div class="field mt-4 flex gap-2">
            <div class="w-12">
                <FloatLabel>
                    <Textarea id="observacoes" v-model="form.observacoes" class="w-full" rows="5" />
                    <label for="observacoes">Observações</label>
                </FloatLabel>
                <div class="text-xs text-red-500">{{ errors['observacoes'] }}</div>
            </div>
        </div>

        <ClienteListaSelect :visible="visibleClienteListaSelect" :permissoes="permissoes" @close="visibleClienteListaSelect=false" @select="selectCliente" />
    </div>

</template>
<script>
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import AutoComplete from 'primevue/autocomplete';
import DatePicker from 'primevue/datepicker';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import Panel from 'primevue/panel';

import Estado from '@/service/estado.js';
import Cidade from '@/service/cidade.js';
import Solicitante from '@/service/solicitante.js';
import Etapa from '@/service/etapa.js';
import Usuario from '@/service/usuario.js';

import ClienteListaSelect from '@/page/cliente/ListaSelect.vue';

import axios from 'axios';

export default {
    components: { FloatLabel,
                  InputGroup,
                  InputGroupAddon,
                  Button,
                  InputText,
                  InputMask,
                  Select,
                  Textarea,
                  AutoComplete,
                  Checkbox,
                  DatePicker,
                  InputNumber,
                  Panel,

                  ClienteListaSelect,
                },
    props: {
        form: {},
        errors: {},
        permissoes: {},
    },
    emits: ['save','close','consultaCep','selectCliente'],
    data() {
        return {
            isLoading: false,

            solicitanteOpt: [],
            isLoadingSolicitanteOpt: false,

            etapaOpt: [],
            isLoadingEtapaOpt: false,

            responsavelOpt: [],
            isLoadingResponavelOpt: false,

            estadoOpt: [],
            isLoadingEstadoOpt: false,

            cidadeOpt: [],
            isLoadingCidadeOpt: false,
            filteredCidades: null,

            isLoadingCep: false,
            visibleClienteListaSelect: false,

            estadoId: null,
        }
    },
    mounted() {
        this.loadEstadoOpt();
        this.loadSolicitanteOpt();
        this.loadEtapaOpt();
        this.loadUsuarioOpt();
    },
    updated() {
        if(this.estadoId === null && this.form.estado_id) {
            this.loadCidadeOpt(this.form.estado_id);
        }
    },
    methods: {
        selectCliente(cliente) {
            this.$emit('selectCliente', cliente);
        },
        clearCliente() {
            this.$emit('selectCliente', null);
        },
        onEstadoChange(event) {
            this.form.cidade_id = null;
            if(event.value) {
                this.loadCidadeOpt(event.value);
            }
        },
        onCepChange(event) {
            if(this.form.cep) {
                const cep       = this.form.cep.replace(/\D/g, '');
                const cepUrl    = `https://viacep.com.br/ws/${cep}/json/`;

                this.isLoadingCep = true;
                axios.get(cepUrl)
                    .then(({data}) => {
                        if(data.erro) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: 'CEP não encontrado.', life: 3000 });
                            return;
                        }

                        let dados = {
                            endereco1: data.logradouro,
                            endereco2: data.complemento,
                        };

                        Cidade.ufNome(data.uf, data.localidade)
                            .then(response => {
                                this.loadCidadeOpt(response.data.estado_id);
                                dados.estado_id = response.data.estado_id;
                                dados.cidade_id = response.data.id;
                            })
                            .finally(() => {
                                this.$emit('consultaCep', dados);
                            });
                    })
                    .finally(() => this.isLoadingCep = false);
            }
        },
        loadUsuarioOpt() {

            this.isLoadingResponavelOpt = true;
            Usuario.option(['order[nome]=asc'].join("&"))
                .then(response => {
                    this.responsavelOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingResponavelOpt = false;
                });
        },
        loadEtapaOpt() {
            this.isLoadingEtapaOpt = true;
            Etapa.optionParaFormularioContrato()
                .then(response => {
                    this.etapaOpt = response.data;
                    if(!this.form.etapa) {
                        this.form.etapa = this.etapaOpt[0].id;
                    }
                })
                .finally(() => {
                    this.isLoadingEtapaOpt = false;
                });
        },
        loadSolicitanteOpt() {
            this.isLoadingSolicitanteOpt = true;
            Solicitante.option(['order[descricao]=asc'].join("&"))
                .then(response => {
                    this.solicitanteOpt = response.data;
                    if(!this.form.solicitante_id) {
                        this.form.solicitante_id = this.solicitanteOpt[0].id;
                    }
                })
                .finally(() => {
                    this.isLoadingSolicitanteOpt = false;
                });
        },
        loadEstadoOpt() {
            this.isLoadingEstadoOpt = true;
            Estado.option(['order[descricao]=asc'].join("&"))
                .then(response => {
                    this.estadoOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingEstadoOpt = false;
                });
        },
        loadCidadeOpt(estadoId) {
            if(!estadoId) {
                this.cidadeOpt = [];
                return;
            }
            if(this.estadoId == estadoId) {
                return;
            }

            this.estadoId = estadoId;
            this.isLoadingCidadeOpt = true;
            Cidade.option(estadoId, ['order[nome]=asc'].join("&"))
                .then(response => {
                    this.cidadeOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingCidadeOpt = false;
                });
        },
    }
}
</script>

<style>
    .contrato-endereco .p-panel-header {
        padding-bottom: 0;
    }
</style>
